import { Card } from '../../../Common/Charts/Card';
import { currency } from '../../../Common/Util/currency';
import { useHouseholdIncomeChartsDataContext } from './hooks/useHouseholdIncomeChartsDataContext';

export const Indicators = () => {
    const { chartData } = useHouseholdIncomeChartsDataContext();

    return (
        <div className="w-100" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            <Card
                title="Média da Renda Familiar Total"
                value={currency.formatToBrCurrency(
                    chartData?.indicators?.averageFamilyIncomeTotal || 0
                )}
            />
            <Card
                title="Média da Renda Familiar Per Capita"
                value={currency.formatToBrCurrency(
                    chartData?.indicators?.averageFamilyIncomePerCapita || 0
                )}
            />
            <Card
                title="Média da Despesa Familiar"
                value={currency.formatToBrCurrency(
                    chartData?.indicators?.averageFamilyBills || 0
                )}
            />
            <Card
                title="Média do Saldo Familiar"
                value={currency.formatToBrCurrency(
                    chartData?.indicators?.averageFamilyBalance || 0
                )}
            />
        </div>
    );
};
